// extracted by mini-css-extract-plugin
module.exports = {"ColumnarReport":"DataExplorer_ColumnarReport__2-K0q"};